import React from 'react';
import { designationThresholdColumnsList } from '../../constants/MockData';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { SECTIONS } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';

export default class DesignationThreshold extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmMessage: null,
      validationMessage: [],
      designationMasterData: [],
      designationThresholdData: [],
      isInAddMode: false,
      isDelete: false,
      showWarningMessage: false,
      configuration: [],
      selectedEditRowId: undefined,
      isEditEnable: true,
      updateData: {
        designationId: null,
        designationGroupId: 0,
        designation: undefined,
        designationGroup: undefined,
        threshold: 0,
        isDeleteRecord: false
      },
      designationThresholdColumns: _.cloneDeep(designationThresholdColumnsList)
    };
  }

  /**
     *
     */
  componentDidMount() {
    this.getRequiredData();
  }

  /**
* return master data from
*/
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Users.GetDesignationThresholdData,
        key: 'designationThresholdData'
      }

    ])
      .then(({ designationThresholdData, designationMasterData }) => {
        this._asyncRequest = null;
        if (designationMasterData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          designationMasterData: designationMasterData.data || [],
          designationThresholdData: designationThresholdData.data || [],
          configuration: designationThresholdData.config || [],
          reloadTable: !this.state.reloadTable
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  /**
   * add new record in grid table
   * @returns
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const designationThresholdColumns = _.cloneDeep(designationThresholdColumnsList);
    const rowNew = {
      designationId: null,
      designationGroupId: 0,
      designation: undefined,
      designationGroup: undefined,
      threshold: 0
    };

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'designationGroupId', value: 0 },
      reloadTable: !this.state.reloadTable,
      updateData: rowNew,
      designationThresholdColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  EditRecord = (cellInfo) => {
    const designationThresholdColumns = _.cloneDeep(designationThresholdColumnsList);

    this.setState({
      designationThresholdColumns,
      selectedEditRowId: {
        key: 'designationGroupId',
        value: cellInfo.designationGroupId
      },
      isInAddMode: false,
      updateData: cellInfo,
      reloadTable: !this.state.reloadTable
    });
  }

  onClickHandel(e) {
    if (this.state.isDelete) {
      this.onDeleteHandel(e);
    }
    //else {
    //   this.setState({
    //     showWarningMessage: false
    //   });
    //   let newParam = [];
    //   newParam = this.state.updateData;
    //   newParam.splitDesignation = e;
    //   if (e) this.deleteRecord(newParam);
    // }
  }

  deleteRecord(cellInfo) {
    this.setState({
      isDelete: true,
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  onDeleteHandel(e) {
    const newParam = this.state.updateData;
    if (e) {
      newParam.isDeleteRecord = true;
      apiPost({
        url: API_URL.Users.UpdateDesignationThresholdData,
        postBody: newParam
      }
      ).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast('Record deleted successfully.',
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            reloadTable: !this.state.reloadTable,
            isDelete: false,
            showWarningMessage: false
          });
          this.getRequiredData();
          this.forceUpdate();
        } else {
          ShowToast(
            response.message,
            toastType.ERROR,
            5000,
            5000
          );
        }
      });
    } else {
      this.setState({ showWarningMessage: false, confirmationMessage: '' });
    }
  }

  /**
  * render action column on grid table
  * @param {*} cellInfo
  * @param {*} isInAddMode
  * @returns
  */
  renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.designationGroupId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => { }}
                >
                  <SaveIcon
                    fontSize="small"
                    size="small"
                    onClick={this.saveUpdatedRecord

                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_DESIGNATION_THRESHOLD_VARIANCE, SECTIONS.ADD_EDIT)) && (
            <>
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                  this.deleteRecord(cellInfo);
                }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )}
      </>
    );
  };

  /**
 * check if designation is present designation threshold data
 * @param {*} ele
 * @returns
 */
  isDesignationPresent(ele) {
    const existingDesignationId = ele.designationId.split('|');
    const newDesignationId = this.state.updateData.designationId.split('|');

    const matchedDesignation = existingDesignationId.filter((m) =>
      newDesignationId.some((n) => m === n)
    );
    return matchedDesignation;
  }

  /**
   * check if Designation Group Present
   * @param {*} ele
   * @returns
   */
  isDesignationGroupPresent(ele) {
    const existingDesignationId = ele.designationGroupId;
    const newDesignationId = this.state.updateData.designationGroupId;

    const matchedDesignation = existingDesignationId.filter((m) =>
      newDesignationId.some((n) => m === n)
    );
    return matchedDesignation;
  }

  /**
   * check if Designation Exist In Designation Group
   * @returns bool
   */
  isDesignationExistInDesignationGroup() {
    let isValid = false;
    let filterDesignationData = '';
    let breakCondition = false;

    this.state.designationThresholdData.forEach((ele) => {
      if (this.state.isInAddMode && ele.designationGroupId !== this.state.updateData.designationGroupId &&
        ele.designationGroup === this.state.updateData.designationGroup && !breakCondition
      ) {
        // if( ele.designationGroupId == this.state.updateData.designationGroupId) {

        filterDesignationData = ele;
        isValid = true;
        breakCondition = true;
        // }
        // return;
      }
    });
    return isValid;
  }

  /**
   * is Form Valid
   */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, designationThresholdColumns } = this.state;
    designationThresholdColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ designationThresholdColumns }, this.forceUpdate());
    return IsValid;
  };

  /**
   * check if Designation Group Exist
   */
  isDesignationGroupExist() {
    let isValid = false;
    let filterDesignationGroup = '';
    let breakCondition = false;

    this.state.designationThresholdData.forEach((ele) => {
      if (ele.designationGroupId !== this.state.updateData.designationGroupId && !breakCondition
      ) {
        const matchedDesignation = this.isDesignationPresent(ele);
        if (matchedDesignation.length > 0) {
          filterDesignationGroup = ele;
          isValid = true;
          breakCondition = true;
        }
      }
    });
    return isValid;
  }

  deleteSelectedRecord = () => {

  }

  /**
   * save Updated Record to database
   */
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; } else {
      if (this.isDesignationGroupExist() || this.isDesignationExistInDesignationGroup()) {
        ShowToast(
          'Designation or Designation Group already present .Please select different Designation.',
          toastType.ERROR,
          5000,
          500
        );
      } else {
        const newParam = this.state.updateData;
        apiPost({
          url: API_URL.Users.UpdateDesignationThresholdData,
          postBody: newParam
        }
        ).then(({ data: response }) => {
          // debugger;
          if (response.success === true) {
            ShowToast(
              this.state.isInAddMode
                ? 'Record added successfully.'
                : 'Record updated successfully.',
              toastType.SUCCESS,
              5000,
              500
            );

            this.setState({
              updateData: undefined,
              selectedEditRowId: undefined,
              reloadTable: !this.state.reloadTable,
              isInAddMode: false
            });
            this.getRequiredData();
            this.forceUpdate();
          } else {
            ShowToast(
              response.message,
              toastType.ERROR,
              5000,
              5000
            );
          }
        });
      }
    }
  };

  /**
 * handle on change
 * @param {*} value
 * @param {*} fieldName
 */
  handleTableEditChange = (value, fieldName) => {
    const { designationThresholdColumns } = this.state;
    const designationData = this.state.designationMasterData;
    const param = this.state.updateData;
    const validationMessage = this.state.validationMessage;
    if (fieldName === 'designation') {
      const valueOfDesignation = [];
      value.forEach((val) => {
        designationData.find((x) => x.designation === val) &&
          valueOfDesignation.push(
            designationData.find((x) => x.designation === val).designationID
          );
      });
      param.designationId = valueOfDesignation.join('|');
      param[fieldName] = value.join('|');
    } else if (fieldName === 'designationGroup') {
      param[fieldName] = value || [];
    } else {
      param[fieldName] = value;
    }

    param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
    param.userEmail =
      param.userEmail === undefined
        ? 'yogesh.mahabaleshwarkar@streamrealty.com'
        : param.userEmail;

    isGridFormValid(value, designationThresholdColumns.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) });

    this.forceUpdate();
  };

  /**
   * render elements to UI
   * @returns UI
   */
  render() {
    const { designationMasterData, configuration, designationThresholdColumns } = this.state;

    const EditSource = [];
    EditSource.push({
      key: 'designationMasterData',
      data: designationMasterData
    });
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Configure Account Code Name And Threshold Variance
                      </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={UpdateColumnWithConfiguration(
                    designationThresholdColumns,
                    this.state.configuration,
                    []
                  )}
                  data={this.state.designationThresholdData}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: 'Add New Account Code Name and Threshold Variance',
                    visible: IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_DESIGNATION_THRESHOLD_VARIANCE, SECTIONS.ADD_EDIT)
                  }}
                  isInline={true}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
